"use client";

import React from "react";
import Link from "next/link";

interface TextLinkButtonProps {
    text?: string;
    href?: string;
    primaryColor?: string;
    hoverColor?: string;
    arrowDirection?: "right" | "left";
}

const TextLinkButton = ({
                            text = "Subscribe",
                            href = "#",
                            primaryColor = "#111",
                            hoverColor = "#803320",
                            arrowDirection = "right",
                        }: TextLinkButtonProps) => {
    const cssLabel = JSON.stringify(text);
    const cssVars = {
        ["--primary-color" as any]: primaryColor,
        ["--hovered-color" as any]: hoverColor,
        ["--label" as any]: cssLabel,
        ["--arrow-shift" as any]: arrowDirection === "left" ? "-4px" : "4px",
        ["--arrow-order" as any]: arrowDirection === "left" ? 0 : 1,
        ["--text-order" as any]: arrowDirection === "left" ? 1 : 0,
    } as React.CSSProperties;

    return (
        <div className="text-link-btn" style={cssVars}>
            <style jsx>{`
                .text-link-btn {
                    width: fit-content;
                }

                /* Używamy :global(a), żeby styl działał na Link z Next.js */
                .text-link-btn :global(a) {
                    padding: 0;
                    margin: 0;
                    border: none;
                    background: none;
                    cursor: pointer;
                    position: relative;
                    display: inline-flex;
                    gap: 0.5rem;
                    align-items: center;
                    font-size: 14px;
                    text-decoration: none;
                    -webkit-tap-highlight-color: transparent;
                }

                .text-link-btn p {
                    margin: 0;
                    position: relative;
                    font-size: 14px;
                    color: var(--primary-color);
                    font-weight: 500;
                    order: var(--text-order);
                }

                .text-link-btn :global(a)::after {
                    position: absolute;
                    content: "";
                    width: 0;
                    left: 0;
                    bottom: -6px;
                    background: var(--hovered-color);
                    height: 2px;
                    transition: width 0.3s ease;
                }

                .text-link-btn p::before {
                    position: absolute;
                    content: var(--label);
                    inset: 0;
                    width: 0%;
                    color: var(--hovered-color);
                    overflow: hidden;
                    white-space: nowrap;
                    transition: width 0.3s ease;
                }

                .text-link-btn svg {
                    width: 15px;
                    transition: transform 0.2s ease, color 0.2s ease;
                    color: var(--primary-color);
                    order: var(--arrow-order);
                }

                /* ✅ HOVERY TYLKO NA URZĄDZENIACH Z PRAWDZIWYM HOVER (desktop) */
                @media (hover: hover) and (pointer: fine) {
                    .text-link-btn :global(a):hover::after {
                        width: 100%;
                    }

                    .text-link-btn :global(a):hover p::before {
                        width: 100%;
                    }

                    .text-link-btn :global(a):hover svg {
                        transform: translateX(var(--arrow-shift));
                        color: var(--hovered-color);
                    }
                }
            `}</style>

            <Link href={href} scroll={true}>
                <p className="uppercase">{text}</p>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={4}>
                    {arrowDirection === "left" ? (
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    ) : (
                        <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    )}
                </svg>
            </Link>
        </div>
    );
};

export default TextLinkButton;